<template>
  <div>
    <DSHeader title="新增问卷">
      <template slot="button">
        <div>
          <a-button type="primary" @click="goBack" class="back-button">返回</a-button>
        </div>
      </template>
    </DSHeader>
    <Form />
  </div>
</template>

<script>
import Form from '../../components/Form.vue';
import DSHeader from '@/components/DSComponents/DSHeader/index.vue';
export default {
  components: {
    Form,
    DSHeader
  },
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>